var render = function () {
  var _vm$imageItems$_vm$vi;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative max-w-full",
    class: {
      'bg-gray-150': _vm.backgroundColor
    }
  }, [!_vm.$slots.default ? _c('slider', {
    attrs: {
      "show-arrows": _vm.imageItems.length > 1,
      "visible-arrows": _vm.slidesPerView < _vm.imageItems.length,
      "disable-touch": _vm.slidesPerView >= _vm.imageItems.length,
      "show-pagination": _vm.showPagination,
      "slides-per-view": _vm.slidesPerView
    },
    model: {
      value: _vm.visibleIndex,
      callback: function ($$v) {
        _vm.visibleIndex = $$v;
      },
      expression: "visibleIndex"
    }
  }, _vm._l(_vm.imageItems, function (image, mediaIndex) {
    return _c('slider-item', {
      key: mediaIndex,
      attrs: {
        "value": mediaIndex
      }
    }, [_c('cdn-image', {
      staticClass: "cursor-pointer m-auto",
      class: {
        'rounded': _vm.rounded
      },
      attrs: {
        "src": image.preview && image.preview.path ? image.preview.path : image.path,
        "background-color": _vm.backgroundColor,
        "size": image.preview && image.preview.size ? image.preview.size : image.size,
        "alt": image.preview && image.preview.title ? image.preview.title : image.title
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.openIndex(mediaIndex);
        }
      }
    })], 1);
  }), 1) : _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.isActive = true;
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.imageItems.length ? _c('modal', {
    attrs: {
      "no-padding": "",
      "large": ""
    },
    model: {
      value: _vm.isActive,
      callback: function ($$v) {
        _vm.isActive = $$v;
      },
      expression: "isActive"
    }
  }, [_c('slider', {
    staticClass: "w-full h-full",
    attrs: {
      "height": "auto",
      "with-keyboard-navigation": "",
      "slides-per-view": 1,
      "show-arrows": _vm.imageItems.length > 1,
      "disable-touch": _vm.imageItems.length <= 1,
      "visible-arrows": ""
    },
    model: {
      value: _vm.visibleIndex,
      callback: function ($$v) {
        _vm.visibleIndex = $$v;
      },
      expression: "visibleIndex"
    }
  }, _vm._l(_vm.imageItems, function (image, i) {
    return _c('slider-item', {
      key: ("modal-item-" + i),
      staticClass: "flex items-center",
      attrs: {
        "value": i
      }
    }, [_c('cdn-image', {
      staticClass: "cursor-pointer m-auto",
      attrs: {
        "src": image.path,
        "size": image.size ? image.size : {
          width: '100vw',
          sm: {
            height: 400
          },
          lg: {
            height: 600
          },
          xl: {
            height: 600
          }
        },
        "alt": image.title
      },
      on: {
        "click": function ($event) {
          _vm.isActive = true;
        }
      }
    }), _vm._v(" "), _vm.downloadable && image._key ? _c('div', {
      staticClass: "my-5"
    }, [_c('form-btn', {
      attrs: {
        "action": ("/media/files/" + (image._key) + "/download"),
        "method": "get"
      },
      on: {
        "success": _vm.$downloadFile
      }
    }, [_c('icon', {
      attrs: {
        "icon": _vm.$icons.download
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$trans('action.download', 'Herunterladen')))])], 1)], 1) : _vm._e()], 1);
  }), 1), _vm._v(" "), _vm.visibleIndex !== null && (_vm$imageItems$_vm$vi = _vm.imageItems[_vm.visibleIndex]) !== null && _vm$imageItems$_vm$vi !== void 0 && _vm$imageItems$_vm$vi.title ? _c('div', {
    staticClass: "p-16",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('p', {
    staticClass: "mb-0 text-center text-sm"
  }, [_vm._v(_vm._s(_vm.imageItems[_vm.visibleIndex].title))])]) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "button"
  }, [_vm._t("button")], 2)], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }